// src/components/IndustriesSection.js
import React from "react";
import {
  GraduationCap,
  Stethoscope,
  ShoppingCart,
  Truck,
  Banknote,
  Plane,
} from "lucide-react";
import IndustriesIllustration from "../assets/industry-solutions.svg";

const iconClass = "w-6 h-6 text-[#4C47DC]";

const industries = [
  {
    icon: <GraduationCap className={iconClass} />,
    title: "Education",
    description:
      "Smart, scalable platforms for schools and universities to manage academics, operations, and admissions.",
  },
  {
    icon: <Stethoscope className={iconClass} />,
    title: "Healthcare",
    description:
      "Secure systems for managing patient records, telemedicine, and hospital resource tracking.",
  },
  {
    icon: <ShoppingCart className={iconClass} />,
    title: "Retail & E-commerce",
    description:
      "Online storefronts, product management, order tracking, and customer engagement systems.",
  },
  {
    icon: <Truck className={iconClass} />,
    title: "Logistics",
    description:
      "Fleet tracking, delivery scheduling, inventory control, and supply chain optimization.",
  },
  {
    icon: <Banknote className={iconClass} />,
    title: "Finance",
    description:
      "Payment systems, data-driven dashboards, and fintech integrations for modern businesses.",
  },
  {
    icon: <Plane className={iconClass} />,
    title: "Travel & Hospitality",
    description:
      "Custom booking platforms, itinerary planning tools, and CRM systems for service providers.",
  },
];

const IndustriesSection = () => {
  return (
    <section id="industries" className="bg-white py-20">
      <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-16 items-center">
        {/* Left: Illustration */}
        <div className="hidden md:block">
          <img
            src={IndustriesIllustration}
            alt="Industries We Serve"
            className="w-full h-auto"
          />
        </div>

        {/* Right: Industry List */}
        <div>
          <h2 className="text-3xl font-bold text-[#4C47DC] mb-8">
            Industries We Serve
          </h2>

          <ul className="space-y-6">
            {industries.map((industry, index) => (
              <li key={index} className="flex items-start space-x-4 group">
                <div className="flex-shrink-0">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-gray-100 transition-transform duration-300 group-hover:scale-105">
                    {industry.icon}
                  </div>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-900">
                    {industry.title}
                  </h3>
                  <p className="text-sm text-gray-600">{industry.description}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default IndustriesSection;
